import { useState, type ChangeEvent } from 'react';
import { useHistory } from 'react-router';

import { Button, Form, Header, Icon, Segment } from '@mairistem/composants';

import { TYPE_ACTE_OPTIONS } from '@/constants';
import type { TypeActe } from '@/types';

const Dashboard = () => {
  const history = useHistory();

  const [identifiantActe, setIdentifiantActe] = useState('3');
  const [identifiantActeIndividu, setIdentifiantActeIndividu] =
    useState('218169');
  const [codeMention, setCodeMention] = useState('706702');
  const [typeActe, setTypeActe] = useState<TypeActe>('naissance');

  const handleOpenSelection = () => {
    history.push('/assistant');
  };

  const handleOpenAvecParams = () => {
    const params = new URLSearchParams({
      identifiantActe,
      identifiantActeIndividu,
      codeMention,
      typeActe,
    });
    history.push(`/assistant?${params.toString()}`);
  };

  const isFormValid =
    identifiantActe.trim() !== '' &&
    identifiantActeIndividu.trim() !== '' &&
    codeMention.trim() !== '';

  return (
    <div
      style={{
        padding: '2em',
        display: 'flex',
        flexDirection: 'column',
        gap: '1.5em',
        maxWidth: '600px',
      }}
    >
      <Segment raised>
        <Header as="h3">
          <Icon name="list" />
          <Header.Content>Mode sélection</Header.Content>
        </Header>
        <Button color="blue" onClick={handleOpenSelection}>
          <Icon name="arrow right" />
          Ouvrir l&apos;assistant
        </Button>
      </Segment>

      <Segment raised>
        <Header as="h3">
          <Icon name="search" />
          <Header.Content>Mode vérification (démo)</Header.Content>
        </Header>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            handleOpenAvecParams();
          }}
        >
          <Form.Input
            label="Identifiant Acte"
            placeholder="Ex : 42"
            value={identifiantActe}
            onChange={(
              _e: ChangeEvent<HTMLInputElement>,
              data: { value: string },
            ) => setIdentifiantActe(data.value)}
          />
          <Form.Input
            label="Identifiant Acte Individu"
            placeholder="Ex : 123"
            value={identifiantActeIndividu}
            onChange={(
              _e: ChangeEvent<HTMLInputElement>,
              data: { value: string },
            ) => setIdentifiantActeIndividu(data.value)}
          />
          <Form.Input
            label="Code mention"
            placeholder="Ex : 706702"
            value={codeMention}
            onChange={(
              _e: ChangeEvent<HTMLInputElement>,
              data: { value: string },
            ) => setCodeMention(data.value)}
          />
          <Form.Select
            label="Type d'acte"
            options={TYPE_ACTE_OPTIONS}
            value={typeActe}
            onChange={(
              _e: ChangeEvent<HTMLInputElement>,
              data: { value: TypeActe },
            ) => setTypeActe(data.value)}
          />
          <Button color="blue" type="submit" disabled={!isFormValid}>
            <Icon name="arrow right" />
            Ouvrir l&apos;assistant
          </Button>
        </Form>
      </Segment>
    </div>
  );
};

export default Dashboard;
